import { ToggleInstance } from '@/connection/integrations/integrations';
import { serializeError } from '@/store/utils/serialize-error';
import { EMappedIntegrationTypes } from '@/types/integrations.types';
import { ChannelSettingsReducerCreator } from '../types';

const toggleSolutionInstanceReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        userId,
        channel,
        instanceId,
        enabled,
        type,
      }: { userId: string; channel: number; instanceId: string; enabled: boolean; type?: EMappedIntegrationTypes },
      { rejectWithValue }
    ) => {
      try {
        const instances = await ToggleInstance(userId, channel, instanceId, enabled, type);
        return instances;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.solutionInstances) {
          const updatedInstance = action.payload;

          state.solutionInstances = state.solutionInstances.map((instance) => {
            if (instance.id === updatedInstance.id) {
              return {
                ...instance,
                enabled: updatedInstance.enabled,
              };
            } else {
              return instance;
            }
          });
        }
      },
    }
  );
};

export default toggleSolutionInstanceReducer;
